import { render } from "./ApprovalModal.vue?vue&type=template&id=56c12d1b&scoped=true"
import script from "./ApprovalModal.vue?vue&type=script&lang=js"
export * from "./ApprovalModal.vue?vue&type=script&lang=js"

import "./ApprovalModal.vue?vue&type=style&index=0&id=56c12d1b&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56c12d1b"]])

export default __exports__